import { render } from "./BancaliUscitaView.vue?vue&type=template&id=4f74c5db&scoped=true"
import script from "./BancaliUscitaView.vue?vue&type=script&lang=js"
export * from "./BancaliUscitaView.vue?vue&type=script&lang=js"

import "./BancaliUscitaView.vue?vue&type=style&index=0&id=4f74c5db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f74c5db"]])

export default __exports__